<div id="wrapper">
  <edc-demo-access-denied-banner *ngIf="isUnauthorized" resourceName="the catalog" details="Please sign in with an account that has access, or ask an admin to grant permissions."></edc-demo-access-denied-banner>
  
  <ng-container *ngIf="!isUnauthorized">
    <div class="search-pagination-container">
      <mat-form-field class="search-form-field" color="accent">
        <mat-label>Search catalog</mat-label>
        <input (input)="onSearch()" [(ngModel)]="searchText" matInput [disabled]="isUnauthorized">
        <mat-icon matPrefix>search</mat-icon>
        <button (click)="searchText=''; onSearch()" *ngIf="searchText && !isUnauthorized" mat-icon-button matSuffix>
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
  
      <mat-paginator *ngIf="!isUnauthorized"
        [length]="paginationState.filteredList.length"
        [hidePageSize]="false"
        [pageIndex]="paginationState.pageIndex"
        [pageSize]="paginationState.pageSize"
        [pageSizeOptions]="[10, 20, 50]"
        (page)="onPageChange($event)"
      />
    </div>

    <div fxLayout="row wrap" fxLayoutAlign="start start">
        <mat-card
          *ngFor="let contractOffer of paginationState.pagedList; trackBy: trackByAssetId"
          class="asset-card clickable"
          tabindex="0"
          (click)="onOfferClicked(contractOffer)"
          (keydown.enter)="onOfferClicked(contractOffer)"
          (keydown.space)="$event.preventDefault(); onOfferClicked(contractOffer)"
        >
            <mat-card-header>
                <mat-icon mat-card-avatar>attachment</mat-icon>
                <mat-card-title
                  class="overflow-ellipsis"
                  #nameDiv
                  [matTooltip]="utilService.shouldShowTooltip(nameDiv, contractOffer.properties.name) ? contractOffer.properties.name : ''"
                  matTooltipPosition="below"
                  matTooltipClass="tooltip"
                >
                  {{contractOffer.properties.name}}
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <mat-list dense>
                    <mat-list-item>
                      <mat-icon matListItemIcon>category</mat-icon>
                      <div class="asset-property-name" matListItemTitle>Type</div>
                        <div matListItemLine
                          class="overflow-ellipsis"
                          #typeDiv
                          [matTooltip]="utilService.shouldShowTooltip(typeDiv, contractOffer.properties.type) ? contractOffer.properties.type : ''"
                          matTooltipPosition="below"
                          matTooltipClass="tooltip"
                        >
                          {{contractOffer.properties.type}}
                        </div>
                    </mat-list-item>
                    <mat-list-item>
                      <mat-icon matListItemIcon>key</mat-icon>
                      <div class="asset-property-name" matListItemTitle>Id</div>
                        <div matListItemLine
                          class="overflow-ellipsis"
                          #assetIdDiv
                          [matTooltip]="utilService.shouldShowTooltip(assetIdDiv, contractOffer.assetId) ? contractOffer.assetId : ''"
                          matTooltipPosition="below"
                          matTooltipClass="tooltip"
                        >
                          {{contractOffer.assetId}}
                        </div>
                    </mat-list-item>
                    <mat-list-item *ngIf="contractOffer.originator">
                        <mat-icon matListItemIcon>link</mat-icon>
                      <div class="asset-property-name" matListItemTitle>Originator</div>
                        <div matListItemLine
                          class="overflow-ellipsis"
                          #originatorDiv
                          [matTooltip]="utilService.shouldShowTooltip(originatorDiv, contractOffer.originator) ? contractOffer.originator : ''"
                          matTooltipPosition="below"
                          matTooltipClass="tooltip"
                        >
                          {{contractOffer.originator}}
                        </div>
                    </mat-list-item>
                </mat-list>
            </mat-card-content>
        </mat-card>
    </div>
  </ng-container>
</div>
